import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Container, List, ListItem, Paper, Stack, Typography } from "@mui/material";
import { useAppDispatch } from '../../store';
import { navigate } from '../../store/slices/breadcrumbSlice';
import { PlayArrow, RunCircle } from '@mui/icons-material';
import { collection, doc, DocumentData, endBefore, getDoc, getDocs, getFirestore, limit, limitToLast, orderBy, Query, query, QueryDocumentSnapshot, QuerySnapshot, setDoc, startAfter, startAt, where, writeBatch } from 'firebase/firestore';
import employeeConverter from '../../converters/employeeConverter';
import { Employee, EmployeeStatus } from '../../types/Employee';
import vacationRequestConverter from '../../converters/vacationRequestConverter';
import { DateTime } from 'luxon';
import timeClockConverter from '../../converters/timeClockConverter';
import { batch } from 'react-redux';
import medicalPaperRequestConverter from '../../converters/medicalPaperRequestConverter';
import { UmrahPaperRequest } from '../../types/UmrahPaperRequest';
import umrahPaperRequestConverter from '../../converters/umrahPaperRequestConverter';

export const AdminIndex = () => {
  const dispath = useAppDispatch();

  const [runOneRunning, setRunOneRunning] = useState(false);
  const [runTwoRunning, setRunTwoRunning] = useState(false);
  const [runThreeRunning, setRunThreeRunning] = useState(false);

  const runCleanEmployees = () => {
    if (runOneRunning) return;

    setRunOneRunning(true);
    // Get all employees
    const db = getFirestore();
    const a = getDocs(query(collection(db, 'Employees')).withConverter(employeeConverter))
      .then(qColSnapshot => {
        let count = 0;
        let batch = writeBatch(db);
        try {
          qColSnapshot.docs.forEach(qDocSnapshot => {
            const e = qDocSnapshot.data();
            if (e.taggedForDeletion && e.status !== 'Inactive') {
              batch.set(qDocSnapshot.ref, { status: 'Inactive' }, { merge: true });
            } //else {
              //batch.set(qDocSnapshot.ref, { status: 'Active' }, { merge: true });
            //}
  
            count++;
            if (count % 500 === 0) {
              batch.commit();
              batch = writeBatch(db);
            }
          });
        } catch {

        }
      });
    const b = getDocs(query(collection(db, 'Vacations'), where('requestStatus', '==', 'Approved'), where('status', '==', 'In Progress')).withConverter(vacationRequestConverter))
      .then(qColSnapshot => {
        const batch = writeBatch(db);
        try {
          qColSnapshot.docs.forEach(qDocSnapshot => {
            const v = qDocSnapshot.data();
            const ref = doc(db, `Employees/${v.idNumber}`);
            batch.set(ref, { status: 'On Vacation' }, {merge: true});
          });
          batch.commit();
        } catch {

        }
      });
    const c = getDocs(query(collection(db, `TimeClocks/${DateTime.now().toFormat('yyyyMMdd')}/Employees`)).withConverter(timeClockConverter))
      .then(qColSnapshot => {
        let count = 0;
        let batch = writeBatch(db);
        try {
          qColSnapshot.docs.forEach(qDocSnapshot => {
            const t = qDocSnapshot.data();
            const ref = doc(db, `Employees/${t.idNumber}`);
            batch.set(ref, { taggedForDeletion: false, status: 'Active' }, {merge: true});
            
            count++;
            if (count % 500 === 0) {
              batch.commit();
              batch = writeBatch(db);
            }
          });
          batch.commit();
        } catch {

        }
      });
    Promise.allSettled([a, b, c]).then(() => {
      setRunOneRunning(false);
    });
  };

  const runTwo = () => {
    if (runTwoRunning) return;
    
    setRunTwoRunning(true);

    const db = getFirestore();
    const q = (status: string) => {
      return getDocs(query(collection(db, 'Vacations'), where('requestStatus', '==', 'Approved'), where('status', '==', status)).withConverter(vacationRequestConverter))
        .then(qColSnapshot => {
          let count = 0;
          let batch = writeBatch(db);
          try {
            qColSnapshot.docs.forEach(qDocSnapshot => {
              const v = qDocSnapshot.data();
              const ref = doc(db, `Employees/${v.idNumber}/Vacations/${v.id}`);
              batch.set(ref, { status }, {merge: true});
              
              count++;
              if (count % 500 === 0) {
                batch.commit();
                batch = writeBatch(db);
              }
            });
            batch.commit();
          } catch {

          }
        });
    };
    
    const a = q('In Progress');
    const b = q('Completed');

    const date = DateTime.utc().toFormat('yyyyMMdd');
    const c = getDocs(query(collection(db, 'Vacations'), where('status', '==', 'Requested'), where('requestStatus', '==', 'Approved'), where('dateStart', '<=', date)).withConverter(vacationRequestConverter))
      .then(qColSnapshot => {
        const batch = writeBatch(db);
        qColSnapshot.docs.forEach(d => {
          const v = d.data();
          batch.set(doc(db, `Employees/${v.idNumber}`), { status: 'On Vacation' }, {merge: true});
          batch.set(doc(db, `Employees/${v.idNumber}/Vacations/${v.id}`), { status: 'In Progress' }, {merge: true});
        });
        batch.commit();
      });

    Promise.allSettled([a, b, c]).then(() => {
      setRunTwoRunning(false);
    });
  };

  const runThree = () => {
    if (runThreeRunning) return;

    setRunThreeRunning(true);

    const db = getFirestore();
    getDocs(query(collection(db, 'Employees')).withConverter(employeeConverter)).then(qSnapshot => {
      const batch = writeBatch(db);
      qSnapshot.docs.forEach(dSnapshot => {
        const d = dSnapshot.data();
        if (d.status === undefined) {
          let status: EmployeeStatus = 'Active';
          if (d.taggedForDeletion) {
            // Set status to 'Inactive'
            console.log(`Employee ${d.idNumber} is tagged for deletion! Setting status to inactive!`);
            status = 'Inactive';
          } else {
            // Set status to 'Active'
            console.log(`Employee ${d.idNumber} status is not set, setting status to 'Active'.`);
            status = 'Active';
          }

          batch.set(doc(db, `Employees/${d.idNumber}`), { status }, { merge: true });
        }
      });
      batch.commit();

      setRunThreeRunning(false);
    });
  };

  const abc = () => {
    const db = getFirestore();
    console.log('Running');
    getDocs(query(collection(db, 'Employees')).withConverter(employeeConverter))
      .then(qColSnapshot => {
        try {
          Promise.allSettled(qColSnapshot.docs.map(async qDocSnapshot => {
            const e = qDocSnapshot.data();
            const iqamaDocSnap = await getDoc(doc(db, `Employees/${e.idNumber}/PersonalDocuments/Iqama`));
            const passportDocSnap = await getDoc(doc(db, `Employees/${e.idNumber}/PersonalDocuments/Passport`));

            let iqama = undefined;
            let passport = undefined;

            if (iqamaDocSnap.exists()) {
              iqama = {
                ...iqamaDocSnap.data(),
                type: 'Iqama',
                idNumber: e.idNumber,
                name: e.name,
              }
            }

            if  (passportDocSnap.exists()) {
              passport = {
                ...passportDocSnap.data(),
                type: 'Passport',
                idNumber: e.idNumber,
                name: e.name,
              };
            }

            return {
              iqama,
              passport
            }
          })).then((result) => {
            let count = 0;
            (result as PromiseFulfilledResult<any>[]).forEach(async (v) => {
              try {
                const { iqama, passport } = v.value;
                if (iqama) {
                  await setDoc(doc(db, `Employees/${iqama.idNumber}/PersonalDocuments/Iqama`), iqama, { merge: true });
                  await setDoc(doc(db, `PersonalDocuments/Iqama/List/${iqama.idNumber}`), iqama, {merge: true});
                }
  
                if (passport) {
                  await setDoc(doc(db, `Employees/${passport.idNumber}/PersonalDocuments/Passport`), passport, { merge: true });
                  await setDoc(doc(db, `PersonalDocuments/Passport/List/${passport.idNumber}`), passport, {merge: true});
                }
              } catch (err) {
                console.log(err);
              }
            });
            console.log('End');
          });
        } catch {
          console.log('err');
        }
      });
  };

  const abc1 = () => {
    const db = getFirestore();
    getDocs(query(collection(db, 'Employees')).withConverter(employeeConverter))
      .then(qColSnapshot => {
        try {
          Promise.allSettled(qColSnapshot.docs.map(async qDocSnapshot => {
            const e = qDocSnapshot.data();
            return (await getDocs(collection(db, `Employees/${e.idNumber}/UmrahPaperRequests`).withConverter(umrahPaperRequestConverter))).docs.map(d => ({
              ...d.data(),
              status: 'New',
            }));
          })).then((result) => {
            const requests: UmrahPaperRequest[] = [];
            (result as PromiseFulfilledResult<UmrahPaperRequest[]>[]).forEach(async (v) => {
              v.value.forEach(m => {
                requests.push(m);
              })
            });
            return requests;
          }).then(requests => {
            let count = 0;
            let batch = writeBatch(db);
            requests.forEach(m => {
              batch.set(doc(db, `Employees/${m.idNumber}/UmrahPaperRequests/${m.id}`), m, { merge: true });
              batch.set(doc(db, `UmrahPaperRequests/${m.id}`), m, { merge: true });

              count++;
              if (count % 500 === 0) {
                batch.commit();
                batch = writeBatch(db);
              }
            });
            return batch.commit();
          }).finally(() => {
            console.log('End');
          });
        } catch (error) {
          console.log(error);
        }
      });
  };

  useEffect(() => {
    dispath(navigate({
      title: 'Admin',
      link: '/admin',
    }));
  }, []);

  return (
    <Container disableGutters>
      <Box mb={2}>
        <Typography variant='h3' color='red'>WARNING!</Typography>
        <Typography variant='h6' color='orange'>Don't click below buttons if you are not sure!</Typography>
      </Box>
      <Stack spacing={2}>
        <Card>
          <Box p={2}>
            <Typography variant='h6'>Clean Employees</Typography>
            <Typography variant='body1'>
              This function will update employee status based on below factors:
            </Typography>
            <ul style={{ margin: 0 }}>
              <li><Typography variant='caption'></Typography>Update status to 'Inactive' when employee is tagged for deletion.</li>
              <li><Typography variant='caption'></Typography>Update status to 'On Vacation' when employee is currently on vacation. </li>
              <li><Typography variant='caption'></Typography>Update status to 'Active' and tagForDeletion to 'false' when employee have attendance. </li>
            </ul>
            <Box mt={2}>
              <Button disabled={runOneRunning} variant='contained' startIcon={<PlayArrow />} onClick={runCleanEmployees}>Run</Button>
            </Box>
          </Box>
        </Card>
        <Card>
          <Box p={2}>
            <Typography variant='h6'>Clean Employee Vacations</Typography>
            <Typography variant='body1'>
              This function will update employee vacation requests based on below factors:
            </Typography>
            <ul style={{ margin: 0 }}>
              <li><Typography variant='caption'></Typography>Update employee data.</li>
            </ul>
            <Box mt={2}>
              <Button disabled={runTwoRunning} variant='contained' startIcon={<PlayArrow />} onClick={runTwo}>Run</Button>
            </Box>
          </Box>
        </Card>
        <Card>
          <Box p={2}>
            <Typography variant='h6'>Set Employee Status</Typography>
            <Typography variant='body1'>
              This function set employee status if status is still not defined
            </Typography>
            <Box mt={2}>
              <Button disabled={runThreeRunning} variant='contained' startIcon={<PlayArrow />} onClick={runThree}>Run</Button>
            </Box>
          </Box>
        </Card>
        <Card>
          <Box p={2}>
            <Typography variant='h6'>Test Run</Typography>
            <Typography variant='body1'>
              Temporary button to run scripts.
            </Typography>
            <Box mt={2}>
              <Button variant='contained' startIcon={<PlayArrow />} onClick={abc1}>Run</Button>
            </Box>
          </Box>
        </Card>
      </Stack>
    </Container>
  );
};

